import '../../App.css';
import '../../css/bootstrap.scss';
import google_icon from "../../images/google.png";
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useState, useRef } from 'react';
import config from '../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setPassword, setwizardPageNumber, setFaceID, setAccessToken } from '../LoginReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import CameraModal from '../Camera/CameraModal';
import { AxiosError } from 'axios';
import { compose } from 'redux';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { validateEmail, getUserID, getUserData } from '../../Utils/user';

interface FormData {
    email: string;
    password: string;
}

interface Props { };

const SecondForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.loginAccount.wizardPageNumber);
    const [loginValidation, setLoginValidation] = useState(false);

    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [eyeStatus, setEyeStatus] = useState(true);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const startLoading = () => {
        setLoading(true);
    };

    const [showPassword, setShowPassword] = useState(false);
    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const checkPassword = (value: any) => {
        if (!value) {
            setEyeStatus(false);
            return t('common.password_required');
        } else {
            setEyeStatus(true);
        }
        return undefined;
    };

    const loginMFA = async (email: string, password: string) => {
        try {
            const login = await axios.post(config.NODE_API_BASE_URL + '/wso2/login', {
                username: email,
                password: password
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                if (reason.response!.status != 200) {
                    setLoginValidation(true);
                }
            });

            if (login?.data.access_token) {
                return login?.data.access_token;
            } else {
                return 0;
            }
        } catch (error: any) {
            console.error(error);
        }
    };

    const handleChangeEmail = (e: any) => {
        if (e.target.value) {
            setLoginValidation(false);
        }
    };

    const handleChangePassword = (e: any) => {
        if (e.target.value) {
            setLoginValidation(false);
        }
    };

    const submitMFAForm = async (formValues: FormData) => {
        const email = formValues.email;
        const password = formValues.password;

        setIsSubmitted(true);
        startLoading();
        const access_token = await loginMFA(email, password);

        if (access_token) {
            localStorage.setItem('access_token', access_token);
            dispatch(setEmail(email));
            dispatch(setPassword(password));
            dispatch(setAccessToken(access_token));
            const userID = await getUserID(email);
            const userData = await getUserData(userID);

            let totpStatus = 'false';
            if (userData['urn:ietf:params:scim:schemas:extension:enterprise:2.0:User']?.totpEnabled) {
                totpStatus = userData['urn:ietf:params:scim:schemas:extension:enterprise:2.0:User']?.totpEnabled;
            }
            if (totpStatus == 'true') {
                dispatch(setwizardPageNumber(page + 2));
            }
            if (totpStatus == 'false') {
                dispatch(setwizardPageNumber(page + 1));
            }
        }
        setIsSubmitted(false);
        setValidated(true);
    };

    return (
        <Form noValidate={true} onSubmit={handleSubmit(submitMFAForm)} className='mt-5'>
            <Row>
                <Col md={11}>
                    {loginValidation && (
                        <p className='text-danger text-start small fw-bold'>
                            {t('login.invalid_credentials')}
                        </p>
                    )}
                    <label className="form-label">{t('login.email_phone')}</label>

                    <Field
                        name="email"
                        type="email"
                        component={renderField}
                        className="form-control rounded-5 py-2 mt-2"
                        placeholder={t('login.enter_email')}
                        id="email"
                        validate={validateEmail}
                        required
                        onChange={handleChangeEmail}
                    />
                </Col>
            </Row>
            <Row className=''>
                <Col md={11}>
                    <label htmlFor="password" className="form-label mt-3 ">{t('common.password')}</label>
                    <div className='input-group password_field'>
                        <Field
                            type={showPassword ? 'text' : 'password'}
                            component={renderField}
                            className="form-control rounded-5 py-2 mt-2"
                            placeholder={t('login.enter_password')}
                            id="password"
                            name="password"
                            validate={checkPassword}
                            required
                            onChange={handleChangePassword}
                        />
                        {eyeStatus &&
                            <span
                                className="bg-transparent border-0 icon p-eye"
                                onClick={handleTogglePassword}
                            >
                                <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'} ></i>
                            </span>
                        }
                    </div>
                </Col>
            </Row>

            <Row className=''>
                <Col md={6} className='py-4'>
                    <Button variant="primary" type="submit" className="btn btn-primary px-4 py-2  mt-3 rounded-5" disabled={(loading && isSubmitted)}>
                        {loading && isSubmitted && (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='mx-2'
                            />
                        )}
                        <span>{t('login.login_btn')}</span>
                    </Button>{' '}
                </Col>
                <Col md={6} className='py-5'>
                    <Link to={"/ResetPassword"} className=''>{t('login.forgot')}</Link>
                </Col>
            </Row>

            <Row className='py-1'>
                <div className="col-md-12 d-flex align-items-center justify-content-center">
                    <hr className="flex-grow-1 mx-4" />
                    <div className="centered-text text-secondary">{t('login.or_continue')}</div>
                    <hr className="flex-grow-1 mx-4" />
                </div>
            </Row>
            <Row className='mt-3'>
                <Col md={6}>
                    <Button
                        className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                        onClick={() => { navigate('/register_entity_account') }}
                        style={{ border: '1px solid #C5CCD6' }}
                    >
                        <img src={google_icon} style={{ width: '20px' }} />
                        &nbsp;
                        <span className='small'>{t('login.google')}</span>
                    </Button>
                </Col>
                <Col md={6}>
                    <Button
                        className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                        onClick={() => { navigate('/register_entity_account') }}
                        style={{ border: '1px solid #C5CCD6' }}
                    >
                        <i className="fa-brands fa-apple" style={{ fontSize: '21px' }} ></i>
                        &nbsp; &nbsp;
                        <span className='small'>{t('login.apple')}</span>
                    </Button>
                </Col>
            </Row>
            <Row className='text-center mt-5 mb-5'>
                <span>{t('login.no_account_q')} <Link className='text-primary' to={"/"}>{t('login.register_link')}</Link></span>
            </Row>
        </Form>
    );
};

const mapStateToProps = (state: RootState) => ({
    initialValues: {
        email: '',
        password: '',
    },
});

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizardSecond',
    enableReinitialize: true,
})(SecondForm);

export default connect(mapStateToProps)(form);
